import React, { useEffect, useState } from "react";
import { Box, Button, Card, Grid, IconButton, Typography } from "@mui/material";
import { useForm, useWatch, useFieldArray, set } from "react-hook-form";
import { yesOrNo, approvedOrShortfall, siteInspRecommendation, vacantOrBuilt } from "../../citizen/TCPForms/data";
import { useDispatch } from "react-redux";
import { updateChecklistFormField } from "@egovernments/digit-ui-module-core/src/redux/actions/ownerEMOChecklist";
import ButtonWrapper from "../../citizen/TCPForms/components/Button";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";
import { updateInspectionReportData } from "@egovernments/digit-ui-module-core/src/redux/actions/formMapSite";
import DemoParinted from "../../../../../templates/ApplicationDetails/components/RichTextArea";
import FileUploader from "../../citizen/AVPForms/reusableComponents/FileUploader2";
import { useSelector } from "react-redux";
import FileUploaderNew from "../../citizen/AVPForms/reusableComponents/FileUploaderMuiltple";
import InspectionPhotoViewer from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocumentViewSite";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import dayjs from "dayjs";
import MapSiteInspection from "./mapSiteInspection";

const BasicSiteInspectionReport = ({ formData, callInspectionDetailsAPI, userRolesArray, onSelect, isFromDashboard, detailData,handleTabChange }) => {
  const [expandedRows, setExpandedRows] = useState(["front"]); // 'front' row expanded initially
  const [expandedRowsConstruction, setExpandedRowsConstruction] = useState(["Construction"]); // 'front' row expanded initially
  const [docPopupData, setDocPopupData] = useState(null);
  const [showDocPopup, setShowDocPopup] = useState(false);
  const getSitePhotoByJE = detailData?.flatMap((item) => item.inspectionDetails?.inspectionReportData?.documentInspection || []);
  // const [disabledValue, setDisabledValue] = useState(false);
  const filteredDocuments = formData?.documents.filter((doc) => doc.documentType === "sitePhoto");
  const isRevalidation = formData?.land_Id;
  //   console.log(filteredDocuments,"sitePhotoDocuments");
  console.log("fromsiteInspection", detailData);

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  const sessionData = JSON.parse(sessionStorage.getItem("inspectionReportData"));
  const defaultValues = {
    ...sessionData,
    siteInspecionAnyOtherSide: [
      {
        sideName: "",
        onsiteMeasurement: "",
        observation: "",
        remarks: "",
      },
    ],
  };
  const { documents } = useSelector((state) => state.formMT);
  const reduxFormData = useSelector((state) => state?.inspectionReportData);
  const isJE = userRolesArray?.[0]?.code === "JE";
  const { handleSubmit, control, reset, watch } = useForm({ defaultValues });
  const dispatch = useDispatch();
  const [isPossessionAreaDiff, setIsPossessionAreaDiff] = useState("");
  const [regStatus, setregStatus] = useState("");
  const [storedData, setStoredData] = useState(null);
  const [developerRemarks, setDeveloperRemarks] = useState(null);
  const [siteInspectionDocs, setSiteInspectionDocs] = useState([]);
  // const [siteInspectionVideos, setSiteInspectionVideos] = useState([]);
  const [disabledData, setDisabledData] = useState(null);
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  const isCompounding = formData?.natureOfConstruction === "Compounding";
  // const [uploadedFiles, setUploadedFiles] = useState({});
  const Modal = useModal();
  const handleChange = (e) => {
    console.log("e", e, e.target.name, e.target.value);

    const { name, value } = e.target;
    dispatch(updateChecklistFormField(name, value));
    if (name === "isPossesionAreaDiff") {
      setIsPossessionAreaDiff(value);
    } else if (name === "registryStatus") {
      setregStatus(value);
    }
  };

  const toggleRow = (sectionKey) => {
    setExpandedRows((prev) => (prev.includes(sectionKey) ? prev.filter((key) => key !== sectionKey) : [...prev, sectionKey]));
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "siteInspecionAnyOtherSide",
  });

  const [openRows, setOpenRows] = useState({});
  // const
  const toggleRowConstruction = (sectionKey) => {
    setExpandedRowsConstruction((prev) => (prev.includes(sectionKey) ? prev.filter((key) => key !== sectionKey) : [...prev, sectionKey]));
  };

  const toggleRows = (rowId) => {
    setOpenRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  const onSubmit = async(data) => {
    // console.log("Form submitted:", data, siteInspectionDocs);

    data.inspectionReportData = {
      ...data.inspectionReportData,
      developerRemarks: developerRemarks,
      documentInspection: siteInspectionDocs,
      // documentInspectionVideos: siteInspectionVideos,
      // siteInspecionTimeForm: values.siteInspecionTimeForm?.format("HH:mm") || "",
      siteInspecionTimeForm: dayjs(data.siteInspecionTimeForm?.$d).format("HH:mm") || "",
      siteInspecionTimeTO: dayjs(data.siteInspecionTimeTO?.$d).format("HH:mm") || "",
      // siteInspecionTimeTO: values.siteInspecionTimeTO?.format("HH:mm") || "",
    };
    console.log("Form submitted1", data);

    dispatch(updateInspectionReportData(data));
    if (isJE && formData?.inspectionDetailData === null) {
      handleSubmitUpdate(data);
    } else if (isJE && data?.siteInspecionDueDateArea === null) {
      handleSubmitUpdate(data);
    } else {
      callInspectionDetailsAPI(data);
      handleTabChange(5);
    }

    // Modal("Site Inspection Report", `Site Inspection Report for <strong>${formData?.applicationNo}</strong> updated.`, "success");
    // setCurrentTab(4);
    // callInspectionDetailsAPI(data)
  };

  useEffect(() => {
    const userRoleCode = userRolesArray?.[0]?.code;

    if (userRoleCode === "JE" && formData?.inspectionDetailData === null) {
      setDisabledData(true);
    } else {
      setDisabledData(false);
    }
  }, [userRolesArray, formData]);

  const handleInputChange = (e, name, value) => {
    const currentData = JSON.parse(sessionStorage.getItem("inspectionReportData")) || {};
    currentData[name] = value;
    sessionStorage.setItem("inspectionReportData", JSON.stringify(currentData));
  };

  useEffect(() => {
    const storedChecklist = JSON.parse(sessionStorage.getItem("inspectionReportData"));
    if (storedChecklist) {
      setStoredData(storedChecklist);
    }
    // if(formData?.inspectionDetailData?.siteInspecionDateArea === null && isJE ){
    //    setDisabledValue(true)
    // }else{
    //     setDisabledValue(false)
    // }
  }, []);

  const openPopupDocument = (filteredDocuments) => {
    console.log("filteredfromopen", filteredDocuments);

    setDocPopupData(filteredDocuments);
    setShowDocPopup(true);
  };

  console.log("reduxFormData", reduxFormData, defaultValues, sessionData);

  const handleSubmitUpdate = (data) => {
    const workflow = {
      action: "NOWORKFLOW",
      comments: "",
    };
    const appData = {
      ...formData,
      workflow,
      inspectionDetailData: isJE ? data : formData?.inspectionDetailData,
    };
    console.log("LetterOfAttachment", data);
    updateApiCall.mutate(
      { BPA: appData },
      {
        onSuccess: (result) => {
          console.log("result", result);
          onSelect("", result?.BPA?.[0]);
          Modal(`Application `, `Application <strong>(${formData?.applicationNo})</strong>Updated Successfully!`, "success");
        },
      }
    );
  };

  console.log("formDatabasicSiteiNspect", formData, storedData);
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className="formContainer"
          style={{ marginTop: "18px" }}
          onBlur={(e) => {
            handleInputChange(e, e.target.name, e.target.value);
          }}
        >
          <Card className="inspection-Card-bottom">
            <div className="formHeaderContainer">
              <h2 className="formHeading">Site Inspection Form</h2>
            </div>

            <Grid container spacing={2} sx={{ mt: 2, mb: 2, px: 2 }}>
              {/* Inspection On */}
              <Grid item xs={4}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ fontWeight: "bold", justifyContent: "space-between" }}>
                    Inspection On <span style={{ color: "red" }}>*</span>
                  </Typography>

                  <InputWrapper
                    width="150px"
                    type="datePicker"
                    control={control}
                    defaultValue={formData?.inspectionDetailData?.siteInspecionDateArea}
                    onChange={handleChange}
                    name="siteInspecionDateArea"
                    disablePast
                    hasLabel={false}
                  />
                </Box>
              </Grid>

              {/* Time From */}
              <Grid item xs={4}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ fontWeight: "bold", justifyContent: "space-between" }}>
                    Time From <span style={{ color: "red" }}>*</span>
                  </Typography>

                  <InputWrapper
                    width="150px"
                    type="timePicker"
                    control={control}
                    defaultValue={
                      storedData?.siteInspecionTimeForm
                        ? dayjs(storedData.siteInspecionTimeForm, "HH:mm")
                        : formData?.inspectionDetailData?.siteInspecionTimeForm
                          ? dayjs(formData.inspectionDetailData.siteInspecionTimeForm, "HH:mm")
                          : null
                    }
                    onChange={handleChange}
                    name="siteInspecionTimeForm"
                    hasLabel={false}
                  />
                </Box>
              </Grid>

              {/* Time To */}
              <Grid item xs={4}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ fontWeight: "bold", justifyContent: "space-between" }}>
                    Time To <span style={{ color: "red" }}>*</span>
                  </Typography>

                  <InputWrapper
                    width="150px"
                    type="timePicker"
                    control={control}
                    defaultValue={storedData?.siteInspecionTimeTo || formData?.inspectionDetailData?.siteInspecionTimeTo}
                    onChange={handleChange}
                    name="siteInspecionTimeTO"
                    hasLabel={false}
                  />
                </Box>
              </Grid>

              {/* Site Photo */}
              <Grid item xs={4}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography sx={{ fontWeight: "bold", width: 140 }}>Site Photo:</Typography>

                  <IconButton onClick={() => openPopupDocument(filteredDocuments)}>
                    <VisibilityIcon />
                  </IconButton>
                </Box>
              </Grid>

              {/* Button */}
              <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", pr: 4 }}>
                <ButtonWrapper variant="contained" color="secondary" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
              </Grid>
            </Grid>
          </Card>

          {/* GEO Location */}

          <Card className="inspection-Card-bottom">
            <div className="formHeaderContainer">
              <h2 className="formHeading">GEO Location</h2>
            </div>
            <Grid container spacing={2} style={{ display: "flex", marginTop: "10px", marginBottom: "20px" }}>
              <Grid item xs={4} style={{ display: "flex" }}>
                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333", display: "flex", marginLeft: "10px" }}>
                  Latitude {isRevalidation && <span style={{ color: "red" }}> *</span>}:
                </Typography>
                <Typography variant="body2" sx={{ color: "#555", marginLeft: "10px" }}>
                  {formData?.descriptionOfLand?.latitude}
                </Typography>
              </Grid>
              <Grid item xs={4} style={{ display: "flex" }}>
                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333", display: "flex", marginLeft: "10px" }}>
                  Longitude {isRevalidation && <span style={{ color: "red" }}> *</span>}:
                </Typography>
                <Typography variant="body2" sx={{ color: "#555", marginLeft: "10px" }}>
                  {formData?.descriptionOfLand?.longitude}
                </Typography>
              </Grid>
              <Grid item xs={4} style={{ display: "flex" }}>
                <Typography variant="body2" sx={{ color: "#555", marginLeft: "10px" }}>
                  <MapSiteInspection formData={formData} />
                </Typography>
              </Grid>

              {/* <Grid item xs={4} style={{ display: "flex" }}>
                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333", display: "flex", marginLeft: "10px" }}>
                  Latitude
                </Typography>
                <Typography variant="body2" sx={{ color: "#555", marginLeft: "10px" }}>
                  <InputWrapper
                      width="150px"
                      type="number"
                      control={control}
                      defaultValue={storedData?.siteInspecionLatitudee || formData?.inspectionDetailData?.siteInspecionLatitude}
                      onChange={handleChange}
                      name="siteInspecionLatitude"
                      hasLabel={false}
                    />
                  <InputWrapper
                    label="Latitude"
                    hasLabel={false}
                    width="150px"
                    control={control}
                    placeholder="Enter Latitude"
                    name="siteInspecionLatitude"
                    type="decimal"
                    minLength={8}
                    maxLength={10}
                  />
                </Typography>
              </Grid> */}
              {/* <Grid item xs={4} style={{ display: "flex" }}>
                <Typography variant="body2" sx={{ fontWeight: "bold", color: "#333", display: "flex", marginLeft: "10px" }}>
                  Longitude :
                </Typography>
                <Typography variant="body2" sx={{ color: "#555", marginLeft: "10px" }}>
                  <InputWrapper
                      width="150px"
                      type="number"
                      control={control}
                      defaultValue={storedData?.siteInspecionLongitude || formData?.inspectionDetailData?.siteInspecionLongitude}
                      onChange={handleChange}
                      name="siteInspecionLongitude"
                      hasLabel={false}
                    />
                  <InputWrapper
                    label="Longitude"
                    hasLabel={false}
                    width="150px"
                    control={control}
                    placeholder="Enter Longitude"
                    name="siteInspecionLongitude"
                    type="decimal"
                    maxLength={10}
                    minLength={8}
                  />
                </Typography>
              </Grid> */}
            </Grid>
          </Card>
          {formData?.riskType === "LOW" && (
            <Card className="inspection-Card-bottom">
              <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
                <thead>
                  <tr style={{ background: "#f2f2f2" }}>
                    <th style={tableHeaderLable}>Description</th>
                    <th style={tableHeader}>As on Plan</th>
                    <th className="mandatoryInfo" style={tableHeader}>
                      As on Site <span style={{ color: "red" }}>*</span>
                    </th>
                    <th style={tableHeader}>Observation</th>
                    <th style={tableHeader}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={tableCell}>Construction Status </td>
                    <td style={tableCell}>
                      <InputWrapper
                        width="150px"
                        type="textInput"
                        control={control}
                        defaultValue={storedData?.siteInspecionConstruction || formData?.inspectionDetailData?.siteInspecionConstruction}
                        // onChange={handleChange}
                        name="siteInspecionConstruction"
                        hasLabel={false}
                      />
                    </td>
                    <td style={tableCell}>
                      <InputWrapper
                        disabled={disabledData}
                        width="150px"
                        control={control}
                        name="siteInspecionConstructionONSite"
                        data={vacantOrBuilt}
                        type="radioButton"
                        // onChange={handleChange}
                        hasLabel={false}
                        defaultValue={storedData?.siteInspecionConstructionONSite || formData?.inspectionDetailData?.siteInspecionConstructionONSite}
                      />
                    </td>
                    <td style={tableCell}>
                      <InputWrapper
                        disabled={disabledData}
                        width="150px"
                        control={control}
                        name="siteInspectionConstructionObservation"
                        type="selectInput"
                        data={approvedOrShortfall}
                        defaultValue={
                          storedData?.siteInspectionConstructionObservation || formData?.inspectionDetailData?.siteInspectionConstructionObservation
                        }
                        hasLabel={false}
                      />
                    </td>
                    <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                      <InputWrapper
                        disabled={disabledData}
                        width="100%"
                        type="textInput"
                        control={control}
                        multiLine
                        height={"60px"}
                        maxLength={100}
                        defaultValue={
                          storedData?.siteInspecionConstructionStatusRemarks || formData?.inspectionDetailData?.siteInspecionConstructionStatusRemarks
                        }
                        // onChange={handleChange}
                        name="siteInspecionConstructionStatusRemarks"
                        hasLabel={false}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </Card>
          )}
          <Card className="inspection-Card-Top">
            <div className="formHeaderContainer">
              <h2 className="formHeading">Dimension of each side of property in SqM.</h2>
            </div>
            {/* <div className="table-responsive">
                            <table className="table" 
                            style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px", fontFamily: 'sans-serif' }}>
                                <thead>
                                    <tr style={{ background: "#f2f2f2" }}>
                                        <th style={tableHeader}>Description</th>
                                        <th style={tableHeader}>As on Plan</th>
                                        <th style={tableHeader}>As on Site</th>
                                        <th style={tableHeader}>Observation</th>
                                        <th style={tableHeader}>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={tableCell} colSpan={5} onClick={() => toggleRow('front')}>a) Front Side {expandedRows.includes('front') ? '▲' : '▼'}</td>
                                             <td style={tableCell}><InputWrapper
  disabled={disabledData}
                                            width="150px"
                                            type="textInput"
                                            control={control}
                                            defaultValue={storedData?.siteInspecionFrontSide || formData?.inspectionDetailData?.siteInspecionFrontSide}
                                            // onChange={handleChange}
                                            name="siteInspecionFrontSide"
                                            hasLabel={false}
                                        />
                                        </td>
                                        <td style={tableCell}>

                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="number"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionFrontSideONSite || formData?.inspectionDetailData?.siteInspecionFrontSideONSite}
                                                // onChange={handleChange}
                                                name="siteInspecionFrontSideONSite"
                                                hasLabel={false} />

                                        </td>
                                        <td style={tableCell}>

                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                control={control}
                                                name="siteInspectionFrontSideObservation"

                                                type="selectInput"
                                                data={approvedOrShortfall}
                                                defaultValue={storedData?.siteInspectionFrontSideObservation || formData?.inspectionDetailData?.siteInspectionFrontSideObservation}
                                                hasLabel={false}
                                            />
                                        </td>
                                        <td style={tableCell}>

                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="textInput"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionFrontSideRemarks || formData?.inspectionDetailData?.siteInspecionFrontSideRemarks}
                                                // onChange={handleChange}
                                                name="siteInspecionFrontSideRemarks"
                                                hasLabel={false} />
                                        </td>
                                    </tr>
                                    {expandedRows.includes('front') && (
                                        <React.Fragment>
                                    <tr>
                                        <td style={tableCell}>b) Rear Side</td>
                                        <td style={tableCell}>

                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="textInput"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionRearSide || formData?.inspectionDetailData?.siteInspecionRearSide}
                                                // onChange={handleChange}
                                                name="siteInspecionRearSide"
                                                hasLabel={false} />
                                        </td>
                                        <td style={tableCell}>

                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="number"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionRearSideONSite || formData?.inspectionDetailData?.siteInspecionRearSideONSite}
                                                // onChange={handleChange}
                                                name="siteInspecionRearSideONSite"
                                                hasLabel={false} />
                                        </td>
                                        <td style={tableCell}>
                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                control={control}
                                                name="siteInspectionRearSideObservation"

                                                type="selectInput"
                                                data={approvedOrShortfall}
                                                defaultValue={storedData?.siteInspectionRearSideObservation || formData?.inspectionDetailData?.siteInspectionRearSideObservation}
                                                hasLabel={false}
                                            />
                                        </td>
                                        <td style={tableCell}>
                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="textInput"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionRearSideRemarks || formData?.inspectionDetailData?.siteInspecionRearSideRemarks}
                                                // onChange={handleChange}
                                                name="siteInspecionRearSideRemarks"
                                                hasLabel={false} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={tableCell}>c) Left Side</td>
                                        <td style={tableCell}>

                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="textInput"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionLeftSide || formData?.inspectionDetailData?.siteInspecionLeftSide}
                                                // onChange={handleChange}
                                                name="siteInspecionLeftSide"
                                                hasLabel={false} />
                                        </td>
                                        <td style={tableCell}>
                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="number"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionLeftSideONSite || formData?.inspectionDetailData?.siteInspecionLeftSideONSite}
                                                // onChange={handleChange}
                                                name="siteInspecionLeftSideONSite"
                                                hasLabel={false} />
                                        </td>
                                        <td style={tableCell}><InputWrapper
                                            width="150px"
                                            control={control}
                                            name="siteInspectionLeftSideObservation"

                                            type="selectInput"
                                            data={approvedOrShortfall}
                                            defaultValue={storedData?.siteInspectionLeftSideObservation || formData?.inspectionDetailData?.siteInspectionLeftSideObservation}
                                            hasLabel={false}
                                        />
                                        </td>
                                        <td style={tableCell}>
                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="textInput"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionLeftSideRemarks || formData?.inspectionDetailData?.siteInspecionLeftSideRemarks}
                                                // onChange={handleChange}
                                                name="siteInspecionLeftSideRemarks"
                                                hasLabel={false} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={tableCell}>d) Right Side</td>
                                        <td style={tableCell}>

                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="textInput"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionRightSide || formData?.inspectionDetailData?.siteInspecionRightSide}
                                                // onChange={handleChange}
                                                name="siteInspecionRightSide"
                                                hasLabel={false} />
                                        </td>
                                        <td style={tableCell}>
                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="number"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionRightSideONSite || formData?.inspectionDetailData?.siteInspecionRightSideONSite}
                                                // onChange={handleChange}
                                                name="siteInspecionRightSideONSite"
                                                hasLabel={false} />
                                        </td>
                                        <td style={tableCell}>
                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                control={control}
                                                name="siteInspectionRightSideObservation"

                                                type="selectInput"
                                                data={approvedOrShortfall}
                                                defaultValue={storedData?.siteInspectionRightSideObservation || formData?.inspectionDetailData?.siteInspectionRightSideObservation}
                                                hasLabel={false}
                                            />
                                        </td>
                                        <td style={tableCell}>

                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="textInput"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionRightSideRemarks || formData?.inspectionDetailData?.siteInspecionRightSideRemarks}
                                                // onChange={handleChange}
                                                name="siteInspecionRightSideRemarks"
                                                hasLabel={false} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={tableCell}>e) Any other side</td>
                                        <td style={tableCell}>

                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="textInput"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionAnyOtherSide || formData?.inspectionDetailData?.siteInspecionAnyOtherSide}
                                                // onChange={handleChange}
                                                name="siteInspecionAnyOtherSide"
                                                hasLabel={false} />
                                        </td>
                                        <td style={tableCell}>

                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="number"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionAnyOtherSideONSite || formData?.inspectionDetailData?.siteInspecionAnyOtherSideONSite}
                                                // onChange={handleChange}
                                                name="siteInspecionAnyOtherSideONSite"
                                                hasLabel={false} />
                                        </td>
                                        <td style={tableCell}>

                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                control={control}
                                                name="siteInspectionAnyOtherSideObservation"

                                                type="selectInput"
                                                data={approvedOrShortfall}
                                                defaultValue={storedData?.siteInspectionAnyOtherSideObservation || formData?.inspectionDetailData?.siteInspectionAnyOtherSideObservation}
                                                hasLabel={false}
                                            />
                                        </td>
                                        <td style={tableCell}>

                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="textInput"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionAnyOtherSideRemarks || formData?.inspectionDetailData?.siteInspecionAnyOtherSideRemarks}
                                                // onChange={handleChange}
                                                name="siteInspecionAnyOtherSideRemarks"
                                                hasLabel={false} />
                                        </td>
                                    </tr>
                                    </React.Fragment>
                                    )}
                                </tbody>
 </table>
 </div> */}
            <div className="table-responsive">
              <table
                className="table"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginTop: "10px",
                  fontFamily: "sans-serif",
                }}
              >
                <thead>
                  <tr style={{ background: "#f2f2f2" }}>
                    <th style={{ ...tableHeader, width: "18%" }}>Description</th>
                    <th style={{ ...tableHeader, width: "18%" }}>As on Plan</th>
                    <th style={{ ...tableHeader, width: "18%" }} className="mandatoryInfo">
                      As on Site
                    </th>
                    <th style={{ ...tableHeader, width: "18%" }}>Observation</th>
                    <th style={{ ...tableHeader, width: "28%" }}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ tableCell, display: "flex" }}>
                      a) Front Side{" "}
                      <p
                        colSpan={5}
                        style={{
                          backgroundColor: "#f9f9f9",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        onClick={() => toggleRow("front")}
                      >
                        {expandedRows.includes("front") ? (
                          <RemoveCircleOutlineIcon style={{ fontSize: "20px" }} />
                        ) : (
                          <AddCircleOutlineIcon style={{ fontSize: "20px" }} />
                        )}
                      </p>
                    </td>
                    <td style={tableCell}>
                      <InputWrapper
                        disabled={disabledData}
                        width="150px"
                        type="decimal"
                        placeholder={"Enter plan details"}
                        control={control}
                        defaultValue={storedData?.siteInspecionFrontSide || formData?.inspectionDetailData?.frontSide?.planOn}
                        // onChange={handleChange}
                        name="frontSide.planOn"
                        hasLabel={false}
                      />
                    </td>
                    <td style={tableCell}>
                      <InputWrapper
                        disabled={disabledData}
                        width="150px"
                        type="decimal"
                        placeholder={"Enter site details"}
                        control={control}
                        defaultValue={storedData?.siteInspecionFrontSideONSite || formData?.inspectionDetailData?.frontSide?.onSite}
                        // onChange={handleChange}
                        name="frontSide.onSite"
                        hasLabel={false}
                      />
                    </td>
                    <td style={tableCell}>
                      <InputWrapper
                        disabled={disabledData}
                        width="150px"
                        control={control}
                        name="frontSide.observation"
                        type="selectInput"
                        placeholder={"Select Observation"}
                        data={approvedOrShortfall}
                        defaultValue={storedData?.siteInspectionFrontSideObservation || formData?.inspectionDetailData?.frontSide?.observation}
                        hasLabel={false}
                      />
                    </td>
                    <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                      <InputWrapper
                        disabled={disabledData}
                        width="100%"
                        multiLine
                        height={"60px"}
                        maxLength={100}
                        type="textInput"
                        control={control}
                        defaultValue={storedData?.siteInspecionFrontSideRemarks || formData?.inspectionDetailData?.frontSide?.remarks}
                        // onChange={handleChange}
                        name="frontSide.remarks"
                        hasLabel={false}
                        placeholder={"Enter Remarks"}
                      />
                    </td>
                  </tr>
                  {expandedRows.includes("front") && (
                    <React.Fragment>
                      <tr>
                        <td style={tableCell}>b) Rear Side</td>
                        <td style={tableCell}>
                          <InputWrapper
                            disabled={disabledData}
                            width="150px"
                            type="decimal"
                            placeholder={"Enter plan details"}
                            control={control}
                            defaultValue={storedData?.siteInspecionRearSide || formData?.inspectionDetailData?.rearSide?.planOn}
                            // onChange={handleChange}
                            name="rearSide.planOn"
                            hasLabel={false}
                          />
                        </td>
                        <td style={tableCell}>
                          <InputWrapper
                            disabled={disabledData}
                            width="150px"
                            type="decimal"
                            placeholder={"Enter site details"}
                            control={control}
                            defaultValue={storedData?.siteInspecionRearSideONSite || formData?.inspectionDetailData?.rearSide?.onSite}
                            // onChange={handleChange}
                            name="rearSide.onSite"
                            hasLabel={false}
                          />
                        </td>
                        <td style={tableCell}>
                          <InputWrapper
                            disabled={disabledData}
                            width="150px"
                            control={control}
                            name="rearSide.observation"
                            type="selectInput"
                            placeholder={"Select Observation"}
                            data={approvedOrShortfall}
                            defaultValue={storedData?.siteInspectionRearSideObservation || formData?.inspectionDetailData?.rearSide?.observation}
                            hasLabel={false}
                          />
                        </td>
                        <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                          <InputWrapper
                            disabled={disabledData}
                            width="100%"
                            multiLine
                            height={"60px"}
                            maxLength={100}
                            type="textInput"
                            control={control}
                            defaultValue={storedData?.siteInspecionRearSideRemarks || formData?.inspectionDetailData?.rearSide?.remarks}
                            name="rearSide.remarks"
                            hasLabel={false}
                            placeholder={"Enter Remarks"}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={tableCell}>c) Left Side</td>
                        <td style={tableCell}>
                          <InputWrapper
                            disabled={disabledData}
                            width="150px"
                            type="decimal"
                            placeholder={"Enter plan details"}
                            control={control}
                            defaultValue={storedData?.siteInspecionLeftSide || formData?.inspectionDetailData?.leftSide?.planOn}
                            // onChange={handleChange}
                            name="leftSide.planOn"
                            hasLabel={false}
                          />
                        </td>
                        <td style={tableCell}>
                          <InputWrapper
                            disabled={disabledData}
                            width="150px"
                            type="decimal"
                            placeholder={"Enter site details"}
                            control={control}
                            defaultValue={storedData?.siteInspecionLeftSideONSite || formData?.inspectionDetailData?.leftSide?.onSite}
                            // onChange={handleChange}
                            name="leftSide.onSite"
                            hasLabel={false}
                          />
                        </td>
                        <td style={tableCell}>
                          <InputWrapper
                            disabled={disabledData}
                            width="150px"
                            control={control}
                            name="leftSide.observation"
                            type="selectInput"
                            data={approvedOrShortfall}
                            defaultValue={storedData?.siteInspectionLeftSideObservation || formData?.inspectionDetailData?.leftSide?.observation}
                            hasLabel={false}
                            placeholder={"Select Observation"}
                          />
                        </td>
                        <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                          <InputWrapper
                            disabled={disabledData}
                            multiLine
                            height={"60px"}
                            maxLength={100}
                            width="100%"
                            type="textInput"
                            control={control}
                            defaultValue={storedData?.siteInspecionLeftSideRemarks || formData?.inspectionDetailData?.leftSide?.remarks}
                            // onChange={handleChange}
                            name="leftSide.remarks"
                            hasLabel={false}
                            placeholder={"Enter Remarks"}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td style={tableCell}>d) Right Side</td>
                        <td style={tableCell}>
                          <InputWrapper
                            disabled={disabledData}
                            width="150px"
                            type="decimal"
                            placeholder={"Enter plan details"}
                            control={control}
                            defaultValue={storedData?.siteInspecionRightSide || formData?.inspectionDetailData?.rightSide?.planOn}
                            // onChange={handleChange}
                            name="rightSide.planOn"
                            hasLabel={false}
                          />
                        </td>
                        <td style={tableCell}>
                          <InputWrapper
                            disabled={disabledData}
                            width="150px"
                            type="decimal"
                            placeholder={"Enter site details"}
                            control={control}
                            defaultValue={storedData?.siteInspecionRightSideONSite || formData?.inspectionDetailData?.rightSide?.onSite}
                            // onChange={handleChange}
                            name="rightSide.onSite"
                            hasLabel={false}
                          />
                        </td>
                        <td style={tableCell}>
                          <InputWrapper
                            disabled={disabledData}
                            width="150px"
                            control={control}
                            name="rightSide.observation"
                            type="selectInput"
                            placeholder={"Select Observation"}
                            data={approvedOrShortfall}
                            defaultValue={storedData?.siteInspectionRightSideObservation || formData?.inspectionDetailData?.rightSide?.observation}
                            hasLabel={false}
                          />
                        </td>
                        <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                          <InputWrapper
                            disabled={disabledData}
                            width="100%"
                            multiLine
                            height={"60px"}
                            maxLength={100}
                            type="textInput"
                            control={control}
                            defaultValue={storedData?.siteInspecionRightSideRemarks || formData?.inspectionDetailData?.rightSide?.remarks}
                            // onChange={handleChange}

                            name="rightSide.remarks"
                            hasLabel={false}
                            placeholder={"Enter Remarks"}
                          />
                        </td>
                      </tr>
                      {/* <tr>
                                                <td style={tableCell}>e) Any other side</td>
                                                <td style={tableCell}>

                                                   <InputWrapper
  disabled={disabledData}
                                                        width="150px"
                                                        type="textInput"
                                                        control={control}
                                                        defaultValue={storedData?.siteInspecionAnyOtherSide || formData?.inspectionDetailData?.siteInspecionAnyOtherSide}
                                                        // onChange={handleChange}
                                                        name="siteInspecionAnyOtherSide"
                                                        hasLabel={false} />
                                                </td>
                                                <td style={tableCell}>

                                                   <InputWrapper
  disabled={disabledData}
                                                        width="150px"
                                                        type="number"
                                                        control={control}
                                                        defaultValue={storedData?.siteInspecionAnyOtherSideONSite || formData?.inspectionDetailData?.siteInspecionAnyOtherSideONSite}
                                                        // onChange={handleChange}
                                                        name="siteInspecionAnyOtherSideONSite"
                                                        hasLabel={false} />
                                                </td>
                                                <td style={tableCell}>

                                                   <InputWrapper
  disabled={disabledData}
                                                        width="150px"
                                                        control={control}
                                                        name="siteInspectionAnyOtherSideObservation"

                                                        type="selectInput"
                                                        data={approvedOrShortfall}
                                                        defaultValue={storedData?.siteInspectionAnyOtherSideObservation || formData?.inspectionDetailData?.siteInspectionAnyOtherSideObservation}
                                                        hasLabel={false}
                                                    />
                                                </td>
                                                <td style={tableCell}>

                                                   <InputWrapper
  disabled={disabledData}
                                                        width="150px"
                                                        type="textInput"
                                                        control={control}
                                                        defaultValue={storedData?.siteInspecionAnyOtherSideRemarks || formData?.inspectionDetailData?.siteInspecionAnyOtherSideRemarks}
                                                        // onChange={handleChange}
                                                        name="siteInspecionAnyOtherSideRemarks"
                                                        hasLabel={false} />
                                                </td>
                                            </tr> */}

                      {fields?.map((item, index) => (
                        <tr key={item.id}>
                          <td style={tableCell}>
                            e) Any other side {index + 1}
                            <div style={{ display: "flex", gap: "3px" }}>
                              <button
                                type="button"
                                onClick={() =>
                                  append({
                                    sideName: "",
                                    onsiteMeasurement: "",
                                    observation: "",
                                    remarks: "",
                                  })
                                }
                                style={{
                                  backgroundColor: "#78bad3",
                                  color: "white",
                                  marginRight: "10px",
                                  padding: "2px 4px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px", // small gap between icon and text if you add any text
                                  border: "none",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                <AddCircleOutlineIcon style={{ fontSize: "20px" }} />
                              </button>

                              {fields.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() => remove(index)}
                                  style={{
                                    backgroundColor: "red",
                                    color: "white",
                                    border: "none",
                                    padding: "3px 4px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <RemoveCircleOutlineIcon style={{ fontSize: "20px" }} />
                                </button>
                              )}
                            </div>
                          </td>
                          <td style={tableCell}>
                            <InputWrapper
                              disabled={disabledData}
                              width="150px"
                              type="specialChar"
                              placeholder={"Enter plan details"}
                              control={control}
                              name={`siteInspecionAnyOtherSide.${index}.sideName`}
                              hasLabel={false}
                            />
                          </td>

                          <td style={tableCell}>
                            <InputWrapper
                              disabled={disabledData}
                              width="150px"
                              type="specialChar"
                              placeholder={"Enter site details"}
                              control={control}
                              name={`siteInspecionAnyOtherSide.${index}.onsiteMeasurement`}
                              hasLabel={false}
                            />
                          </td>

                          <td style={tableCell}>
                            <InputWrapper
                              disabled={disabledData}
                              width="150px"
                              type="selectInput"
                              placeholder={"Select Observation"}
                              data={approvedOrShortfall} // your options array
                              control={control}
                              name={`siteInspecionAnyOtherSide.${index}.observation`}
                              hasLabel={false}
                            />
                          </td>

                          <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                            <InputWrapper
                              disabled={disabledData}
                              width="100%"
                              multiLine
                              height={"60px"}
                              maxLength={100}
                              type="textInput"
                              control={control}
                              name={`siteInspecionAnyOtherSide.${index}.remarks`}
                              hasLabel={false}
                              placeholder={"Enter Remarks"}
                            />
                          </td>

                          {/* <td style={tableCell}>
              <button
          type="button"
          onClick={() =>
            append({
              sideName: "",
              onsiteMeasurement: "",
              observation: "",
              remarks: ""
            })
          }
          style={{
            backgroundColor: "blue",
            color: "white",
            marginRight: "10px",
            padding: "5px 10px"
          }}
        >
          Add
        </button>
                {fields.length > 1 && (
                  <button
                    type="button"
                    onClick={() => remove(index)}
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      border: "none",
                      padding: "5px 10px",
                      cursor: "pointer"
                    }}
                  >
                    Remove
                  </button>
                )}
                
              </td> */}
                        </tr>
                      ))}
                    </React.Fragment>
                  )}
                </tbody>
              </table>
            </div>
          </Card>
          <Card className="inspection-Card-Top">
            <div className="formHeaderContainer">
              <h2 className="formHeading">Status of Property/Plot</h2>
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
              <thead>
                <tr style={{ background: "#f2f2f2" }}>
                  <th style={{ ...tableHeader, width: "20%" }}>Description</th>
                  <th style={{ ...tableHeader, width: "15%" }}>As on Plan</th>
                  <th style={{ ...tableHeader, width: "15" }} className="mandatoryInfo">
                    As on Site
                  </th>
                  <th style={{ ...tableHeader, width: "15%" }}>Observation</th>
                  <th style={{ ...tableHeader, width: "35%" }}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {formData?.riskType != "LOW" && (
                  <tr>
                    <td style={tableCell}>
                      Construction Status
                      <p
                        colSpan={5}
                        style={{
                          backgroundColor: "#f9f9f9",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        onClick={() => toggleRowConstruction("Construction")}
                      >
                        {expandedRowsConstruction.includes("Construction") ? (
                          <RemoveCircleOutlineIcon style={{ fontSize: "20px" }} />
                        ) : (
                          <AddCircleOutlineIcon style={{ fontSize: "20px" }} />
                        )}
                      </p>
                    </td>
                    <td style={tableCell}>
                      <InputWrapper
                        width="150px"
                        data={vacantOrBuilt}
                        type="radioButton"
                        // placeholder="Enter the Construction Status"
                        control={control}
                        defaultValue={storedData?.siteInspecionConstruction || formData?.inspectionDetailData?.construction?.planOn}
                        // onChange={handleChange}
                        name="construction.planOn"
                        hasLabel={false}
                      />
                    </td>
                    <td style={tableCell}>
                      <InputWrapper
                        disabled={disabledData}
                        width="150px"
                        control={control}
                        name="construction.onSite"
                        data={vacantOrBuilt}
                        type="radioButton"
                        // onChange={handleChange}
                        hasLabel={false}
                        defaultValue={storedData?.siteInspecionConstructionONSite || formData?.inspectionDetailData?.construction?.onSite}
                      />
                    </td>
                    <td style={tableCell}>
                      <InputWrapper
                        disabled={disabledData}
                        width="150px"
                        control={control}
                        name="construction.observation"
                        type="selectInput"
                        placeholder={"Select Observation"}
                        data={approvedOrShortfall}
                        defaultValue={storedData?.siteInspectionConstructionObservation || formData?.inspectionDetailData?.construction?.observation}
                        hasLabel={false}
                      />
                    </td>
                    <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                      <InputWrapper
                        disabled={disabledData}
                        width="95%"
                        multiLine
                        height={"60px"}
                        maxLength={100}
                        type="textInput"
                        control={control}
                        defaultValue={storedData?.siteInspecionConstructionStatusRemarks || formData?.inspectionDetailData?.construction?.remarks}
                        // onChange={handleChange}
                        name="construction.remarks"
                        hasLabel={false}
                        placeholder={"Enter Remarks"}
                      />
                    </td>
                  </tr>
                )}

                {/* FOR LOW-RISK */}
                {formData?.riskType === "LOW" && (
                  <tr>
                    <td style={tableCell}>
                      Built
                      <p
                        colSpan={5}
                        style={{
                          backgroundColor: "#f9f9f9",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        onClick={() => toggleRowConstruction("Construction")}
                      >
                        {expandedRowsConstruction.includes("Construction") ? (
                          <RemoveCircleOutlineIcon style={{ fontSize: "20px" }} />
                        ) : (
                          <AddCircleOutlineIcon style={{ fontSize: "20px" }} />
                        )}
                      </p>
                    </td>
                    <td style={tableCell}>
                      <InputWrapper
                        disabled={disabledData}
                        width="150px"
                        data={yesOrNo}
                        type="radioButton"
                        control={control}
                        defaultValue={storedData?.siteInspecionBuilttext || formData?.inspectionDetailData?.construction?.siteInspecionBuilttext}
                        // onChange={handleChange}
                        name="construction.siteInspecionBuilttext"
                        hasLabel={false}
                      />
                    </td>
                    <td style={tableCell}>
                      <InputWrapper
                        disabled={disabledData}
                        width="150px"
                        control={control}
                        name="construction.siteInspecionBuilt"
                        data={yesOrNo}
                        type="radioButton"
                        onChange={handleChange}
                        hasLabel={false}
                        defaultValue={storedData?.siteInspecionBuilt || formData?.inspectionDetailData?.siteInspecionBuilt}
                      />
                    </td>
                    <td style={tableCell}>
                      <InputWrapper
                        disabled={disabledData}
                        width="150px"
                        control={control}
                        name="construction.siteInspectionBuiltObservation"
                        type="selectInput"
                        placeholder={"Select Observation"}
                        data={approvedOrShortfall}
                        defaultValue={
                          storedData?.siteInspectionBuiltObservation || formData?.inspectionDetailData?.construction?.siteInspectionBuiltObservation
                        }
                        hasLabel={false}
                      />
                    </td>
                    <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                      <InputWrapper
                        disabled={disabledData}
                        width="95%"
                        multiLine
                        height={"60px"}
                        maxLength={100}
                        type="textInput"
                        control={control}
                        defaultValue={
                          storedData?.siteInspecionBuiltRemarks || formData?.inspectionDetailData?.construction?.siteInspecionBuiltRemarks
                        }
                        // onChange={handleChange}
                        name="construction.siteInspecionBuiltRemarks"
                        hasLabel={false}
                        placeholder={"Enter Remarks"}
                      />
                    </td>
                  </tr>
                )}
                {expandedRowsConstruction.includes("Construction") && (
                  <React.Fragment>
                    {/* High */}
                    {(formData?.riskType === "MEDIUM" || formData?.riskType === "HIGH") && (
                      <tr>
                        <td style={tableCell}>Whether construction started</td>
                        <td style={tableCell}>
                          <InputWrapper
                            disabled={disabledData}
                            width="150px"
                            data={yesOrNo}
                            type="radioButton"
                            control={control}
                            defaultValue={storedData?.siteInspecionWhetherconstruction || formData?.inspectionDetailData?.construction?.planOn}
                            // onChange={handleChange}
                            name="whetherConstructionStarted.planOn"
                            hasLabel={false}
                          />
                        </td>
                        <td style={tableCell}>
                          <InputWrapper
                            disabled={disabledData}
                            width="150px"
                            control={control}
                            name="whetherConstructionStarted.onSite"
                            data={yesOrNo}
                            type="radioButton"
                            onChange={handleChange}
                            hasLabel={false}
                            defaultValue={
                              storedData?.siteInspecionWhetherconstructionONSite || formData?.inspectionDetailData?.whetherConstructionStarted?.onSite
                            }
                          />
                        </td>
                        <td style={tableCell}>
                          <InputWrapper
                            disabled={disabledData}
                            width="150px"
                            control={control}
                            name="whetherConstructionStarted.observation"
                            type="selectInput"
                            placeholder={"Select Observation"}
                            data={approvedOrShortfall}
                            defaultValue={
                              storedData?.siteInspecionWhetherconstructionObservation ||
                              formData?.inspectionDetailData?.whetherConstructionStarted?.observation
                            }
                            hasLabel={false}
                          />
                        </td>
                        <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                          <InputWrapper
                            disabled={disabledData}
                            width="95%"
                            multiLine
                            height={"60px"}
                            maxLength={100}
                            type="textInput"
                            control={control}
                            defaultValue={
                              storedData?.siteInspecionWhetherconstructionRemarks ||
                              formData?.inspectionDetailData?.whetherConstructionStarted?.remarks
                            }
                            // onChange={handleChange}
                            name="whetherConstructionStarted.remarks"
                            hasLabel={false}
                            placeholder={"Enter Remarks"}
                          />
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td style={tableCell}>Demolition Started</td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          // placeholder="Enter the Demolition Started"
                          control={control}
                          defaultValue={storedData?.siteInspecionDemolitionStartedText || formData?.inspectionDetailData?.demolitionStarted?.planOn}
                          onChange={handleChange}
                          name="demolitionStarted.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="demolitionStarted.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.siteInspecionDemolationStarted || formData?.inspectionDetailData?.demolitionStarted?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="demolitionStarted.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionDemolitionObservation || formData?.inspectionDetailData?.demolitionStarted?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionDemolationStartedRemarks || formData?.inspectionDetailData?.demolitionStarted?.remarks
                          }
                          onChange={handleChange}
                          name="demolitionStarted.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Is Property having extra Land</td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={storedData?.siteInspecionPropertyGextra || formData?.inspectionDetailData?.getExtraProperty?.planOn}
                          onChange={handleChange}
                          name="getExtraProperty.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="getExtraProperty.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.siteInspecionPropertyGextraLand || formData?.inspectionDetailData?.getExtraProperty?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="getExtraProperty.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionPropertyGextraLandObservation || formData?.inspectionDetailData?.getExtraProperty?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionPropertyGextraLandRemarks || formData?.inspectionDetailData?.getExtraProperty?.remarks
                          }
                          onChange={handleChange}
                          name="getExtraProperty.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>a) Area of extra land</td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          type="textInput"
                          placeholder={"Enter plan details"}
                          control={control}
                          defaultValue={storedData?.siteInspecionAreaofextra || formData?.inspectionDetailData?.areaOfExtraLand?.planOn}
                          onChange={handleChange}
                          name="areaOfExtraLand.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="areaOfExtraLand.onSite"
                          type="number"
                          placeholder={"Enter site details"}
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.siteInspecionAreaofextraONSite || formData?.inspectionDetailData?.areaOfExtraLand?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="areaOfExtraLand.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspecionAreaofextraObservation || formData?.inspectionDetailData?.areaOfExtraLand?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={storedData?.siteInspecionAreaofextraRemarks || formData?.inspectionDetailData?.areaOfExtraLand?.remarks}
                          onChange={handleChange}
                          name="areaOfExtraLand.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>b)IS extra land allotted by DA/UPAVP/SADA</td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={storedData?.siteInspecionextraLandAllotedBy || formData?.inspectionDetailData?.extraLandAllotedBy?.planOn}
                          onChange={handleChange}
                          name="isExtraLandAllotedBy.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isExtraLandAllotedBy.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.extraLandAllotedBy || formData?.inspectionDetailData?.extraLandAllotedBy?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isExtraLandAllotedBy.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionExtraLandAllotedObservation || formData?.inspectionDetailData?.extraLandAllotedBy?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={storedData?.extraLandAllotedByRemarks || formData?.inspectionDetailData?.isExtraLandAllotedBy?.remarks}
                          onChange={handleChange}
                          name="isExtraLandAllotedBy.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Attached Allotement Letter</td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={storedData?.siteInspecionAttachedAllotement || formData?.inspectionDetailData?.attachedAllotement?.planOn}
                          onChange={handleChange}
                          name="attachedAllotement.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="attachedAllotement.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.attachedAllotement || formData?.inspectionDetailData?.attachedAllotement?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="attachedAllotement.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={storedData?.attachedAllotementObservation || formData?.inspectionDetailData?.attachedAllotement?.observation}
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={storedData?.attachedAllotementRemarks || formData?.inspectionDetailData?.attachedAllotement?.remarks}
                          onChange={handleChange}
                          name="attachedAllotement.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Can a separate property be created</td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={storedData?.seprateProperty || formData?.inspectionDetailData?.separateProperty?.planOn}
                          onChange={handleChange}
                          name="separateProperty.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="separateProperty.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.sepratePropertyONSite || formData?.inspectionDetailData?.seprateProperty?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="separateProperty.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={storedData?.sepratePropertyObservation || formData?.inspectionDetailData?.seprateProperty?.observation}
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={storedData?.sepratePropertyRemarks || formData?.inspectionDetailData?.seprateProperty?.remarks}
                          onChange={handleChange}
                          name="separateProperty.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Is extra land is for offer</td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={storedData?.siteInspecionExtraOffer || formData?.inspectionDetailData?.isExtraLandOffer?.planOn}
                          onChange={handleChange}
                          name="isExtraLandOffer.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isExtraLandOffer.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.extraOfferONSite || formData?.inspectionDetailData?.isExtraLandOffer?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isExtraLandOffer.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionExtraOfferObservation || formData?.inspectionDetailData?.isExtraLandOffer?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={storedData?.siteInspectionExtraOfferRemarks || formData?.inspectionDetailData?.isExtraLandOffer?.remarks}
                          onChange={handleChange}
                          name="isExtraLandOffer.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Is property affected by the water supply</td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={storedData?.siteInspecionaffectedByWater || formData?.inspectionDetailData?.isPropertyAffectedByWater?.planOn}
                          onChange={handleChange}
                          name="isPropertyAffectedByWater.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedByWater.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.affectedByWater || formData?.inspectionDetailData?.isPropertyAffectedByWater?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedByWater.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionAffectedByWaterObservation ||
                            formData?.inspectionDetailData?.isPropertyAffectedByWater?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={storedData?.affectedByWaterRemarks || formData?.inspectionDetailData?.isPropertyAffectedByWater?.remarks}
                          onChange={handleChange}
                          name="isPropertyAffectedByWater.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Is property affected by the sewerage</td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionaffectedBySeweragee || formData?.inspectionDetailData?.isPropertyAffectedBySewerage?.planOn
                          }
                          onChange={handleChange}
                          name="isPropertyAffectedBySewerage.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedBySewerage.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.affectedBySewerage || formData?.inspectionDetailData?.isPropertyAffectedBySewerage?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedBySewerage.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionAffctedBySewarageObservation ||
                            formData?.inspectionDetailData?.isPropertyAffectedBySewerage?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.affectedBySewerageRemarks || formData?.inspectionDetailData?.isPropertyAffectedBySewerage?.remarks
                          }
                          onChange={handleChange}
                          name="isPropertyAffectedBySewerage.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Is property affected by the Electrical Line</td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionaffectedByElectricity || formData?.inspectionDetailData?.isPropertyAffectedByElectricity?.planOn
                          }
                          onChange={handleChange}
                          name="isPropertyAffectedByElectricity.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedByElectricity.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.affectedByElectricity || formData?.inspectionDetailData?.isPropertyAffectedByElectricity?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedByElectricity.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionAffectedElectricityObservation ||
                            formData?.inspectionDetailData?.isPropertyAffectedByElectricity?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.affectedByElectricityRemarks || formData?.inspectionDetailData?.isPropertyAffectedByElectricity?.remarks
                          }
                          onChange={handleChange}
                          name="isPropertyAffectedByElectricity.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Is property affected by the Drainage</td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionaffectedByDrainage || formData?.inspectionDetailData?.isPropertyAffectedByDrainage?.planOn
                          }
                          onChange={handleChange}
                          name="isPropertyAffectedByDrainage.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedByDrainage.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.affectedByDrainage || formData?.inspectionDetailData?.isPropertyAffectedByDrainage?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedByDrainage.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionAffectedDrainageObservation ||
                            formData?.inspectionDetailData?.isPropertyAffectedByDrainage?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.affectedByDrainageRemarks || formData?.inspectionDetailData?.isPropertyAffectedByDrainage?.remarks
                          }
                          onChange={handleChange}
                          name="isPropertyAffectedByDrainage.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Is property affected by railway line</td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionaffectedByRailway || formData?.inspectionDetailData?.isPropertyAffectedByRailway?.planOn
                          }
                          onChange={handleChange}
                          name="isPropertyAffectedByRailway.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedByRailway.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.affectedByRailway || formData?.inspectionDetailData?.isPropertyAffectedByRailway?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedByRailway.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionAffectedRailwayObservation ||
                            formData?.inspectionDetailData?.isPropertyAffectedByRailway?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={storedData?.affectedByRailwayRemarks || formData?.inspectionDetailData?.isPropertyAffectedByRailway?.remarks}
                          onChange={handleChange}
                          name="isPropertyAffectedByRailway.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Is property affected by gas pipe line</td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={storedData?.siteInspecionaffectedByGas || formData?.inspectionDetailData?.isPropertyAffectedByGas?.planOn}
                          onChange={handleChange}
                          name="isPropertyAffectedByGas.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedByGas.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.affectedByGas || formData?.inspectionDetailData?.isPropertyAffectedByGas?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedByGas.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionAffectedGasObservation || formData?.inspectionDetailData?.isPropertyAffectedByGas?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={storedData?.affectedByGasRemarks || formData?.inspectionDetailData?.isPropertyAffectedByGas?.remarks}
                          onChange={handleChange}
                          name="isPropertyAffectedByGas.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Is property affected by any pond/lake or any natural body</td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionaffectedByNaturalBody || formData?.inspectionDetailData?.isPropertyAffectedByNaturalBody?.planOn
                          }
                          onChange={handleChange}
                          name="isPropertyAffectedByNaturalBody.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedByNaturalBody.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={storedData?.affectedByNaturalBody || formData?.inspectionDetailData?.isPropertyAffectedByNaturalBody?.onSite}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPropertyAffectedByNaturalBody.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionAffctedNaturalBodyObservation ||
                            formData?.inspectionDetailData?.isPropertyAffectedByNaturalBody?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.affectedByNaturalBodyRemarks || formData?.inspectionDetailData?.isPropertyAffectedByNaturalBody?.remarks
                          }
                          onChange={handleChange}
                          name="isPropertyAffectedByNaturalBody.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Location/key plan shown on drawing matches property</td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionLocationShownOnDrawing ||
                            formData?.inspectionDetailData?.locationShownOnDrawingMatchesProperty?.planOn
                          }
                          onChange={handleChange}
                          name="locationShownOnDrawingMatchesProperty.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="locationShownOnDrawingMatchesProperty.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={
                            storedData?.LocationShownOnDrawingMatchesProperty ||
                            formData?.inspectionDetailData?.locationShownOnDrawingMatchesProperty?.onSite
                          }
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          control={control}
                          name="locationShownOnDrawingMatchesProperty.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionPlanDrwingMatchObservation ||
                            formData?.inspectionDetailData?.locationShownOnDrawingMatchesProperty?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.locationShownOnDrawingMatchesPropertyRemarks ||
                            formData?.inspectionDetailData?.locationShownOnDrawingMatchesProperty?.remarks
                          }
                          onChange={handleChange}
                          name="locationShownOnDrawingMatchesProperty.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Plot boundaries and Area as per registry matches the site</td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionplotBoundariesandArea ||
                            formData?.inspectionDetailData?.plotBoundariesandAreaAsPerRegisteryMatchesSite?.planOn
                          }
                          onChange={handleChange}
                          name="plotBoundariesandAreaAsPerRegisteryMatchesSite.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="plotBoundariesandAreaAsPerRegisteryMatchesSite.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={
                            storedData?.plotBoundariesandAreaAsPerRegisteryMatchesSite ||
                            formData?.inspectionDetailData?.plotBoundariesandAreaAsPerRegisteryMatchesSite?.onSite
                          }
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="plotBoundariesandAreaAsPerRegisteryMatchesSite.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionRegMatchObservation ||
                            formData?.inspectionDetailData?.plotBoundariesandAreaAsPerRegisteryMatchesSite?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.plotBoundariesandAreaAsPerRegisteryMatchesSiteRemarks ||
                            formData?.inspectionDetailData?.plotBoundariesandAreaAsPerRegisteryMatchesSite?.remarks
                          }
                          onChange={handleChange}
                          name="plotBoundariesandAreaAsPerRegisteryMatchesSite.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Is land of Road widening and green belt falling in the Property</td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionisLandRoadWideningGgreen || formData?.inspectionDetailData?.isLandRoadWideningGgreen?.planOn
                          }
                          onChange={handleChange}
                          name="isLandRoadWideningGgreen.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isLandRoadWideningGgreen.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={
                            storedData?.isLandRoadWideningGgreenBeltFallingInTheProperty ||
                            formData?.inspectionDetailData?.isLandRoadWideningGgreen?.onSite
                          }
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isLandRoadWideningGgreen.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionGreenBeltObservation || formData?.inspectionDetailData?.isLandRoadWideningGgreen?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.isLandRoadWideningGgreenBeltFallingInThePropertyRemarks ||
                            formData?.inspectionDetailData?.isLandRoadWideningGgreen?.remarks
                          }
                          onChange={handleChange}
                          name="isLandRoadWideningGgreen.remarks"
                          hasLabel={false}
                          placeholder={"Enter Remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      {formData?.riskType === "HIGH" && (
                        <React.Fragment>
                          <td style={tableCell}>Width of approach road to reach property (in Mtr)</td>
                          <td style={tableCell}>
                            <InputWrapper
                              disabled={disabledData}
                              width="150px"
                              data={yesOrNo}
                              type="radioButton"
                              control={control}
                              defaultValue={
                                storedData?.siteInspecionWidthOfApprochRoadTo ||
                                formData?.inspectionDetailData?.widthOfApprochRoadToReachProperty?.planOn
                              }
                              onChange={handleChange}
                              name="widthOfApprochRoadToReachProperty.planOn"
                              hasLabel={false}
                            />
                          </td>
                          <td style={tableCell}>
                            <InputWrapper
                              disabled={disabledData}
                              width="150px"
                              control={control}
                              name="widthOfApprochRoadToReachProperty.onSite"
                              data={yesOrNo}
                              type="radioButton"
                              onChange={handleChange}
                              hasLabel={false}
                              defaultValue={
                                storedData?.widthOfApprochRoadToReachProperty ||
                                formData?.inspectionDetailData?.widthOfApprochRoadToReachProperty?.onSite
                              }
                            />
                          </td>
                          <td style={tableCell}>
                            <InputWrapper
                              disabled={disabledData}
                              width="150px"
                              control={control}
                              name="widthOfApprochRoadToReachProperty.observation"
                              type="selectInput"
                              placeholder={"Select Observation"}
                              data={approvedOrShortfall}
                              defaultValue={
                                storedData?.siteInspectionWidthOfRoadObservation ||
                                formData?.inspectionDetailData?.widthOfApprochRoadToReachProperty?.observation
                              }
                              hasLabel={false}
                            />
                          </td>
                          <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                            <InputWrapper
                              disabled={disabledData}
                              width="95%"
                              multiLine
                              height={"60px"}
                              maxLength={100}
                              type="textInput"
                              control={control}
                              defaultValue={
                                storedData?.widthOfApprochRoadToReachPropertyRemarks ||
                                formData?.inspectionDetailData?.widthOfApprochRoadToReachProperty?.remarks
                              }
                              onChange={handleChange}
                              name="widthOfApprochRoadToReachProperty.remarks"
                              hasLabel={false}
                              placeholder={"Enter remarks"}
                            />
                          </td>
                        </React.Fragment>
                      )}
                      {formData?.riskType === "LOW" && (
                        <React.Fragment>
                          <td style={tableCell}>Width of Approch Road to reach property (in Mtr)</td>
                          <td style={tableCell}>
                            <InputWrapper
                              disabled={disabledData}
                              width="150px"
                              data={yesOrNo}
                              type="RadioButton"
                              control={control}
                              defaultValue={
                                storedData?.siteInspecionWidthOfApprochRoadTo ||
                                formData?.inspectionDetailData?.widthOfApprochRoadToReachProperty?.planOn
                              }
                              onChange={handleChange}
                              name="widthOfApprochRoadToReachProperty.planOn"
                              hasLabel={false}
                            />
                          </td>
                          <td style={tableCell}>
                            <InputWrapper
                              disabled={disabledData}
                              width="150px"
                              control={control}
                              name="widthOfApprochRoadToReachProperty.onSite"
                              data={yesOrNo}
                              type="radioButton"
                              onChange={handleChange}
                              hasLabel={false}
                              defaultValue={
                                storedData?.widthOfApprochRoadToReachProperty ||
                                formData?.inspectionDetailData?.widthOfApprochRoadToReachProperty?.onSite
                              }
                            />
                          </td>
                          <td style={tableCell}>
                            <InputWrapper
                              disabled={disabledData}
                              width="150px"
                              control={control}
                              name="widthOfApprochRoadToReachProperty.observation"
                              type="selectInput"
                              placeholder={"Select Observation"}
                              data={approvedOrShortfall}
                              defaultValue={
                                storedData?.siteInspectionWidthOfRoadObservation ||
                                formData?.inspectionDetailData?.widthOfApprochRoadToReachProperty?.observation
                              }
                              hasLabel={false}
                            />
                          </td>
                          <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                            <InputWrapper
                              disabled={disabledData}
                              width="95%"
                              multiLine
                              height={"60px"}
                              maxLength={100}
                              type="textInput"
                              control={control}
                              defaultValue={
                                storedData?.widthOfApprochRoadToReachPropertyRemarks ||
                                formData?.inspectionDetailData?.widthOfApprochRoadToReachProperty?.remarks
                              }
                              onChange={handleChange}
                              name="widthOfApprochRoadToReachProperty.remarks"
                              hasLabel={false}
                              placeholder={"Enter remarks"}
                            />
                          </td>{" "}
                        </React.Fragment>
                      )}
                    </tr>

                    <tr>
                      <td style={tableCell}>Is the proposed property in possession of owner</td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionisProposedProperty || formData?.inspectionDetailData?.isThePropertyPossesionOfOwner?.planOn
                          }
                          onChange={handleChange}
                          name="isThePropertyPossesionOfOwner.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isThePropertyPossesionOfOwner.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={
                            storedData?.isProposedPropertyInPossesionOfOwner || formData?.inspectionDetailData?.isThePropertyPossesionOfOwner?.onSite
                          }
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isThePropertyPossesionOfOwner.observation"
                          type="selectInput"
                          data={approvedOrShortfall}
                          placeholder={"Select Observation"}
                          defaultValue={
                            storedData?.siteInspectionPossOfOwnerObservation ||
                            formData?.inspectionDetailData?.isThePropertyPossesionOfOwner?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.isProposedPropertyInPossesionOfOwnerRemarks ||
                            formData?.inspectionDetailData?.isThePropertyPossesionOfOwner?.remarks
                          }
                          onChange={handleChange}
                          name="isThePropertyPossesionOfOwner.remarks"
                          hasLabel={false}
                          placeholder={"Enter remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>Is plot adjoining any government land/government building</td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionisPlotAdjoiningAny ||
                            formData?.inspectionDetailData?.isPlotAdjoiningAnyGovernmentLandBuilding?.planOn
                          }
                          onChange={handleChange}
                          name="isPlotAdjoiningAnyGovernmentLandBuilding.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPlotAdjoiningAnyGovernmentLandBuilding.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={
                            storedData?.isPlotAdjoiningAnyGovernmentLandBuilding ||
                            formData?.inspectionDetailData?.isPlotAdjoiningAnyGovernmentLandBuilding?.onSite
                          }
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isPlotAdjoiningAnyGovernmentLandBuilding.observation"
                          type="selectInput"
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionGovLandObservation ||
                            formData?.inspectionDetailData?.isPlotAdjoiningAnyGovernmentLandBuilding?.observation
                          }
                          hasLabel={false}
                          placeholder={"Select Observation"}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.isPlotAdjoiningAnyGovernmentLandBuildingRemarks ||
                            formData?.inspectionDetailData?.isPlotAdjoiningAnyGovernmentLandBuilding?.remarks
                          }
                          onChange={handleChange}
                          name="isPlotAdjoiningAnyGovernmentLandBuilding.remarks"
                          hasLabel={false}
                          placeholder={"Enter remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>
                        Infrastructure facilities such as water supply, sewerage, drainage, electrical supply available for property
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          type="radioButton"
                          control={control}
                          data={yesOrNo}
                          defaultValue={
                            storedData?.siteInspecioninfrastructureFacilities ||
                            formData?.inspectionDetailData?.infraFacilitiesAvailableForProperty?.planOn
                          }
                          onChange={handleChange}
                          placeholder={"Enter plan details"}
                          name="infraFacilitiesAvailableForProperty.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          type="radioButton"
                          control={control}
                          data={yesOrNo}
                          placeholder={"Enter site details"}
                          defaultValue={
                            storedData?.infrastructureFacilitiesSupplyAvailbaleForProperty ||
                            formData?.inspectionDetailData?.infraFacilitiesAvailableForProperty?.onSite
                          }
                          onChange={handleChange}
                          name="infraFacilitiesAvailableForProperty.onSite"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="infraFacilitiesAvailableForProperty.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionInfraFacilityObservation ||
                            formData?.inspectionDetailData?.infraFacilitiesAvailableForProperty?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.infrastructureFacilitiesSupplyAvailbaleForPropertyRemarks ||
                            formData?.inspectionDetailData?.infraFacilitiesAvailableForProperty?.remarks
                          }
                          onChange={handleChange}
                          name="infraFacilitiesAvailableForProperty.remarks"
                          hasLabel={false}
                          placeholder={"Enter remarks"}
                        />
                      </td>
                    </tr>
                    {/* <tr>
                      {(formData?.riskType === "MEDIUM" || formData?.riskType === "HIGH") && (
                        <td style={tableCell}>Is proposed plot is affected by by any High-Tension or Low-Tension Power line</td>
                      )}
                      {formData?.riskType === "LOW" && <td style={tableCell}>Is Notice Under Section 83 or Section 27 or Section 28 issued</td>}
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          type="textInput"
                          control={control}
                          defaultValue={storedData?.siteInspecionPowerline || formData?.inspectionDetailData?.siteInspecionPowerline}
                          onChange={handleChange}
                          name="siteInspecionPowerline"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="isProposedPlotIsAffectedByPowerLine"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={
                            storedData?.isProposedPlotIsAffectedByPowerLine || formData?.inspectionDetailData?.isProposedPlotIsAffectedByPowerLine
                          }
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="siteInspectionAffectedPowerObservation"
                          type="selectInput"
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionAffectedPowerObservation ||
                            formData?.inspectionDetailData?.siteInspectionAffectedPowerObservation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.isProposedPlotIsAffectedByPowerLineRemarks ||
                            formData?.inspectionDetailData?.isProposedPlotIsAffectedByPowerLineRemarks
                          }
                          onChange={handleChange}
                          name="isProposedPlotIsAffectedByPowerLineRemarks"
                          hasLabel={false}
                        />
                      </td>
                    </tr> */}
                    <tr>
                      <td style={tableCell}>Does you property lies in the vicinity of the protected monumental of Heritage Destination</td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          data={yesOrNo}
                          type="radioButton"
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionHeritageDestination ||
                            formData?.inspectionDetailData?.IsPropertyLiesInVicinityOfHeritageDestination?.planOn
                          }
                          onChange={handleChange}
                          name="IsPropertyLiesInVicinityOfHeritageDestination.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="IsPropertyLiesInVicinityOfHeritageDestination.onSite"
                          data={yesOrNo}
                          type="radioButton"
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={
                            storedData?.heritageDestination || formData?.inspectionDetailData?.IsPropertyLiesInVicinityOfHeritageDestination?.onSite
                          }
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="IsPropertyLiesInVicinityOfHeritageDestination.observation"
                          type="selectInput"
                          placeholder={"Select Observation"}
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionHeritageDestObservation ||
                            formData?.inspectionDetailData?.IsPropertyLiesInVicinityOfHeritageDestination?.observation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.heritageDestinationRemarks ||
                            formData?.inspectionDetailData?.IsPropertyLiesInVicinityOfHeritageDestination?.remarks
                          }
                          onChange={handleChange}
                          name="IsPropertyLiesInVicinityOfHeritageDestination.remarks"
                          hasLabel={false}
                          placeholder={"Enter remarks"}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={tableCell}>property shortage distance of Heritage destination (in mtr)</td>
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          type="textInput"
                          placeholder={"Enter details"}
                          control={control}
                          defaultValue={
                            storedData?.siteInspecionPropertyShortage ||
                            formData?.inspectionDetailData?.propertyShortageDistanceOfHeritageDestination?.planOn
                          }
                          onChange={handleChange}
                          name="propertyShortageDistanceOfHeritageDestination.planOn"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="propertyShortageDistanceOfHeritageDestination.onSite"
                          type="textInput"
                          placeholder={"Enter details"}
                          onChange={handleChange}
                          hasLabel={false}
                          defaultValue={
                            storedData?.propertyShortage || formData?.inspectionDetailData?.propertyShortageDistanceOfHeritageDestination?.onSite
                          }
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="propertyShortageDistanceOfHeritageDestination.observation"
                          type="selectInput"
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspectionShortDistHeritageObservation ||
                            formData?.inspectionDetailData?.propertyShortageDistanceOfHeritageDestination?.observation
                          }
                          hasLabel={false}
                          placeholder={"Select Observation"}
                        />
                      </td>
                      <td style={{ textAlign: "center", minWidth: "fit-content" }}>
                        <InputWrapper
                          disabled={disabledData}
                          width="95%"
                          multiLine
                          height={"60px"}
                          maxLength={100}
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.propertyShortageRemarks ||
                            formData?.inspectionDetailData?.propertyShortageDistanceOfHeritageDestination?.remarks
                          }
                          onChange={handleChange}
                          name="propertyShortageDistanceOfHeritageDestination.remarks"
                          hasLabel={false}
                          placeholder={"Enter remarks"}
                        />
                      </td>
                    </tr>
                    {/* <tr>
                      {(formData?.riskType === "MEDIUM" || formData?.riskType === "HIGH") && (
                        <td style={tableCell}>Any Other Detail Remark Proposed Site</td>
                      )}
                      {formData?.riskType === "LOW" && <td style={tableCell}>Is Notice Under Section 82 or Section 27 or Section 28 issued</td>}
                      <td style={tableCell}>
                        <InputWrapper
                          width="150px"
                          type="textInput"
                          control={control}
                          defaultValue={storedData?.siteInspecionAnyOtheDetail || formData?.inspectionDetailData?.siteInspecionAnyOtheDetail}
                          onChange={handleChange}
                          name="siteInspecionAnyOtheDetail"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.anyOtherDetailRemarkProposedSite || formData?.inspectionDetailData?.anyOtherDetailRemarkProposedSite
                          }
                          onChange={handleChange}
                          name="anyOtherDetailRemarkProposedSite"
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          control={control}
                          name="siteInspecionAnyOtheDetailObservation"
                          type="selectInput"
                          data={approvedOrShortfall}
                          defaultValue={
                            storedData?.siteInspecionAnyOtheDetailObservation || formData?.inspectionDetailData?.siteInspecionAnyOtheDetailObservation
                          }
                          hasLabel={false}
                        />
                      </td>
                      <td style={tableCell}>
                        <InputWrapper
                          disabled={disabledData}
                          width="150px"
                          type="textInput"
                          control={control}
                          defaultValue={
                            storedData?.anyOtherDetailRemarkProposedSiteRemarks ||
                            formData?.inspectionDetailData?.anyOtherDetailRemarkProposedSiteRemarks
                          }
                          onChange={handleChange}
                          name="anyOtherDetailRemarkProposedSiteRemarks"
                          hasLabel={false}
                        />
                      </td>
                    </tr> */}
                  </React.Fragment>
                )}
              </tbody>
            </table>
          </Card>
          <Card className="inspection-Card-Tb">
            <div className="formHeaderContainer">
              <h2 className="formHeading">Site Inspection Form</h2>
            </div>
            <Grid container spacing={1} style={{ display: "flex", marginTop: "10px", marginBottom: "20px", paddingLeft: "20px" }}>
              <Grid item xs={3}>
                <p>
                  Recommendation <span style={{ color: "red" }}> *</span>
                </p>
              </Grid>
              <Grid item xs={8}>
                <InputWrapper
                  disabled={disabledData}
                  control={control}
                  name="siteInspectionRecommendation"
                  type="selectInput"
                  data={siteInspRecommendation}
                  defaultValue={storedData?.siteInspectionRecommendation || formData?.inspectionDetailData?.siteInspectionRecommendation}
                  hasLabel={false}
                />
              </Grid>
            </Grid>
            {isJE ? (
              <Grid container spacing={1} style={{ display: "flex", marginTop: "10px", marginBottom: "20px", paddingLeft: "20px" }}>
                <Grid item xs={3}>
                  <p> Upload Site Photo</p>
                </Grid>
                <Grid item xs={8}>
                  {/* <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} /> */}
                  {/* <MultipleDocUploader uploadedFiles={uploadedFiles} setUploadedFiles={setUploadedFiles} /> */}

                  <FileUploaderNew
                    // isMandatory
                    // label="Upload Document"
                    control={control}
                    name="siteInspectionDocument"
                    validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                    // required
                    tab={2}
                    maxFiles={5}
                    uploadedDocs={siteInspectionDocs}
                    setUploadedDocs={setSiteInspectionDocs}
                  />
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={1} style={{ display: "flex", marginTop: "10px", marginBottom: "20px", paddingLeft: "20px" }}>
                <Grid item xs={3}>
                  <p> View Site Photo</p>
                </Grid>
                <Grid item xs={8}>
                  <IconButton onClick={() => openPopupDocument(getSitePhotoByJE)} size="small">
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </Grid>
              </Grid>
            )}
            {/* <Grid container spacing={1} style={{ display: 'flex', marginTop: "10px", marginBottom: "20px", paddingLeft: '20px' }}>
                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                control={control}
                                                name="siteInspectionBuiltObservation"

                                                type="selectInput"
                                                data={approvedOrShortfall}
                                                defaultValue={storedData?.siteInspectionBuiltObservation || formData?.inspectionDetailData?.siteInspectionBuiltObservation}
                                                hasLabel={false}
                                            />
                                        </td>
                                        <td style={tableCell}>
                                           <InputWrapper
  disabled={disabledData}
                                                width="150px"
                                                type="textInput"
                                                control={control}
                                                defaultValue={storedData?.siteInspecionBuiltRemarks || formData?.inspectionDetailData?.siteInspecionBuiltRemarks}
                                                // onChange={handleChange}
                                                name="siteInspecionBuiltRemarks"
                                                hasLabel={false} />
                                        </td>
                                    </tr>
                                )}
                                {/* High */}
            <Grid container spacing={1} style={{ display: "flex", marginTop: "10px", marginBottom: "20px", paddingLeft: "20px" }}>
              <Grid item xs={3}>
                <p>Remarks</p>
              </Grid>
              <Grid item xs={8}>
                <DemoParinted setContent={setDeveloperRemarks} content={developerRemarks} />
              </Grid>
            </Grid>
          </Card>
        </div>
        {showDocPopup && (
          <div
            style={{
              position: "fixed",
              top: "15%",
              left: "60%",
              transform: "translateX(-50%)",
              backgroundColor: "#f3f4f6",
              border: "1px solid #ccc",
              padding: "20px",
              zIndex: 1000,
              maxHeight: "80vh",
              overflowY: "auto",
              width: "75%",
              // maxWidth: "800px",
              boxShadow: "0 0 10px rgba(0,0,0,0.3)",
              fontSize: "11px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ fontSize: "14px" }}>Document View</h3>
              <IconButton onClick={() => setShowDocPopup(false)} title="Close">
                <CloseIcon />
              </IconButton>
            </div>
            {docPopupData?.length > 0 ? (
              <InspectionPhotoViewer documentInspection={docPopupData} />
            ) : (
              <p>No documents available for this category.</p>
            )}
          </div>
        )}
        {!isFromDashboard && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper variant="contained" color="secondary" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

const tableHeader = { padding: "10px", border: "1px solid #ccc", textAlign: "left", fontSize: "14px" };
const tableHeaderLable = { padding: "10px", border: "1px solid #ccc", textAlign: "left", fontSize: "14px", width: "100px" };
const tableCell = { padding: "10px", border: "1px solid #ccc", width: "80px", fontSize: "14px", fontFamily: "sans-serif" };
const tableCellLable = { padding: "10px", border: "1px solid #ccc", width: "215px" };
const inputStyle = { width: "100%", padding: "5px", border: "1px solid #ccc", borderRadius: "4px" };
const textareaStyle = { width: "100%", padding: "5px", border: "1px solid #ccc", borderRadius: "4px", height: "50px" };

export default BasicSiteInspectionReport;
